import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { InputMask } from 'primeng/inputmask';
import { InputText } from 'primeng/inputtext';

import { BaseEditPaymentBankAccountComponent } from '../../base/base-edit-payment-bank-account.component';

@Component({
  selector: 'edit-form-bank-account',
  imports: [
    InputText,
    ReactiveFormsModule,
    FormsModule,
    InputMask,
    NgClass
  ],
  templateUrl: './edit-form-bank-account.component.html'
})
export class EditFormBankAccountComponent extends BaseEditPaymentBankAccountComponent {

}
